import { useCallback, useMemo, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { Link, useNavigate } from 'react-router-dom'
import LogoCompass from '../../assets/image/explore.svg'
import LogoProfile from '../../assets/image/face.svg'
import LogoLogout from '../../assets/image/logout.svg'
import LogoNotification from '../../assets/image/notifications.svg'
import LogoHistory from '../../assets/image/manage_history.svg'
import { useAuth } from '../../hooks/useAuth'
import { logout } from '../../store/reducer/authSlice'
import CustomButton from '../UI/CustomButton/CustomButton'
import ModalLogin from '../UI/Popup/ModalLogin'
import SearchBar from '../UI/Search/SearchBar'
import { useGetListNotificationQuery } from '../../services/Notification/notificationAPI'
import { numberedDisplayCount } from '../../utils/number'
import { Button, Popover, Typography } from '@mui/material'
import NotificationItem from '../common/NotificationItem/NotificationItem'

const Header = ({}) => {
  const [open, setOpen] = useState(false)
  const [anchorEl, setAnchorEl] = useState(null)

  const navigate = useNavigate()
  const dispatch = useDispatch()
  const authSLice = useAuth()

  const { isLogged } = authSLice
  const idMe = useSelector((state) => state.account.id)

  const { data: listNoti } = useGetListNotificationQuery(undefined, {
    refetchOnMountOrArgChange: true,
    pollingInterval: 5000,
  })

  const numberBadgeIcon = useMemo(() => {
    const lengthNotification = listNoti?.result?.filter(
      (item) => item?.toAccountStatus === 'Chưa đọc'
    ).length
    const numberBadge = numberedDisplayCount(lengthNotification)
    return numberBadge
  }, [listNoti?.result])

  const handleOpen = () => setOpen(true)
  const handleClose = () => setOpen(false)

  const handleUpPost = useCallback(() => {
    if (!isLogged) {
      setOpen(true)
    } else {
      navigate('up-post')
    }
  }, [navigate, isLogged])

  const handleLogout = useCallback(() => {
    dispatch(logout())
    navigate('home')
  }, [dispatch, navigate])

  const handleChangeRoute = () => {
    if (idMe) {
      navigate(`profile/${idMe}`)
    }
  }

  const handleClickNotification = (event) => {
    setAnchorEl(event.currentTarget)
  }

  const handleCloseNotification = () => {
    setAnchorEl(null)
  }

  const openNotification = Boolean(anchorEl)
  const idNoti = open ? 'simple-popover' : undefined

  return (
    <>
      <header className="p-3 m-auto flex justify-between items-center">
        <Link to="/" className="mr-4">
          <div className="text-[40px] logo leading-[0]">'Exchange</div>
        </Link>
        <SearchBar className={'w-[476px] max-h-[500px]'} />
        <div className="link-page flex items-center ml-4">
          <Link to="/home">
            <img className="w-6	h-6 mr-5 cursor-pointer" src={LogoCompass} alt="" />
          </Link>
          <div className="button-link-page flex">
            {!isLogged && (
              <div className="mr-4">
                <CustomButton name="Đăng nhập" onClick={handleOpen} />
              </div>
            )}
            <div className="mr-4">
              <CustomButton name="Đăng bài" onClick={handleUpPost} />
            </div>

            {isLogged && (
              <div className="flex items-center">
                <Link to="/history">
                  <img className="w-6	h-6 mr-5 cursor-pointer" src={LogoHistory} alt="" />
                </Link>
                <div className="cursor-pointer relative">
                  <img
                    className="w-6	h-6 mr-5 cursor-pointer"
                    aria-describedby={idNoti}
                    onClick={handleClickNotification}
                    src={LogoNotification}
                    alt=""
                  />
                  {numberBadgeIcon > 0 && (
                    <sup
                      className={
                        'absolute right-1 -top-4 flex-center rounded-full text-[12px] font-semibold text-white select-none w-6 h-6 bg-red-500 leading-[23px] text-center'
                      }
                    >
                      {numberBadgeIcon}
                    </sup>
                  )}
                  <Popover
                    id={idNoti}
                    open={openNotification}
                    anchorEl={anchorEl}
                    onClose={handleCloseNotification}
                    anchorOrigin={{
                      vertical: 'bottom',
                      horizontal: 'left',
                    }}
                  >
                    {listNoti?.result.length > 0 ? (
                      listNoti?.result?.map((item, index) => (
                        <NotificationItem key={index} data={item} />
                      ))
                    ) : (
                      <div className="w=[400px] p-2">
                        <Typography>Không có thông báo nào ở đây!</Typography>
                      </div>
                    )}
                  </Popover>
                </div>
                <img
                  className="w-6	h-6 mr-5 cursor-pointer"
                  src={LogoProfile}
                  alt=""
                  onClick={handleChangeRoute}
                />
                <img
                  className="w-6	h-6 mr-5 cursor-pointer"
                  src={LogoLogout}
                  alt=""
                  onClick={handleLogout}
                />
              </div>
            )}
          </div>
        </div>
      </header>
      <ModalLogin open={open} handleClose={handleClose} />
    </>
  )
}

export default Header
